import React, { useState, useRef, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import "./WhyUs.css";
import { useSelector, useDispatch } from 'react-redux';
import { userSelector, clearState, signupUser } from '../../features/User/UserSlice';
import { useNavigate } from 'react-router-dom';
import { Container, Col, Row } from "react-bootstrap";
import Closeicon from "../../../Images/close-icon.png";
import Img1 from "../../../Images/why-trade1.png";
import Img2 from "../../../Images/why-trade2.png";
import Img3 from "../../../Images/why-trade3.png";
import Img4 from "../../../Images/why-trade4.png";
import Img5 from "../../../Images/why-trade5.png";
import Img6 from "../../../Images/why-trade6.png";
import Img7 from "../../../Images/why-trade7.png";
import Img8 from "../../../Images/why-trade8.png";
import Img9 from "../../../Images/why-trade9.png";
import Img10 from "../../../Images/why-trade10.png";
import Img11 from "../../../Images/why-trade11.png";
import Img12 from "../../../Images/why-trade12.png";
import Logo from "../../../Images/Logo.png";
import Popupimg from "../../../Images/start-trading.png";
import Icon1 from "../../../Images/Icon_1.png";
import Icon2 from "../../../Images/Icon_2.png";
import Icon3 from "../../../Images/Icon_3.png";
import Icon4 from "../../../Images/Icon_4.png";
import Icon5 from "../../../Images/Icon_5.png";
import Icon6 from "../../../Images/Icon_6.png";
import Icon7 from "../../../Images/Icon_7.png";
import Icon8 from "../../../Images/Icon_8.png";
import Icon9 from "../../../Images/Icon_9.png";
import Icon10 from "../../../Images/Icon_10.png";
import Icon11 from "../../../Images/Icon_11.png";
import Icon12 from "../../../Images/Icon_12.png";
import Icon13 from "../../../Images/Icon_13.png";
import Icon14 from "../../../Images/Icon_14.png";
import Icon15 from "../../../Images/Icon_15.png";
import Icon16 from "../../../Images/Icon_16.png";
import Icon17 from "../../../Images/Icon_17.png";
import Icon18 from "../../../Images/Icon_18.png";
import Icon19 from "../../../Images/Icon_19.png";
import Icon20 from "../../../Images/Icon_20.png";
import Icon21 from "../../../Images/Icon_21.png";
import Icon22 from "../../../Images/Icon_22.png";
import Icon23 from "../../../Images/Icon_23.png";
import Icon24 from "../../../Images/Icon_24.png";
import Icon25 from "../../../Images/Icon_25.png";
import Icon26 from "../../../Images/Icon_26.png";
import Icon27 from "../../../Images/Icon_27.png";
import Icon28 from "../../../Images/Icon_28.png";
import Icon29 from "../../../Images/Icon_29.png";
import Icon30 from "../../../Images/Icon_30.png";
import Icon31 from "../../../Images/Icon_31.png";
import Icon32 from "../../../Images/Icon_32.png";
import Icon33 from "../../../Images/Icon_33.png";
import whytradefoxtrader from "../../../Images/whytrade/whytrade_foxtrader.png";
import whytradealgo from "../../../Images/whytrade/whytrade_algo.png";
import whytradeoption from "../../../Images/whytrade/whytrade_option.png";
import whytradecrackmarkets from "../../../Images/whytrade/whytrade_crackmarkets.png";
import whytradecrapprice from "../../../Images/whytrade/price.png";
import whytradesupport from "../../../Images/whytrade/support.png";
import { MdClose } from "react-icons/md";
import LoginPopup from "../../CommonUI/LoginPopup/LoginPopup";
import quantmanhome from "../../../Images/whytrade/quantmanhome.png";
function WhyUs() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);

  const [show3, setShow3] = useState(false);
  const handleClose3 = () => setShow3(false);
  const handleShow3 = () => setShow3(true);

  const [show4, setShow4] = useState(false);
  const handleClose4 = () => setShow4(false);
  const handleShow4 = () => setShow4(true);

  const [show5, setShow5] = useState(false);
  const handleClose5 = () => setShow5(false);
  const handleShow5 = () => setShow5(true);

  const [show6, setShow6] = useState(false);
  const handleClose6 = () => setShow6(false);
  const handleShow6 = () => setShow6(true);

  const [show7, setShow7] = useState(false);
  const handleClose7 = () => setShow7(false);
  const handleShow7 = () => setShow7(true);

  const [show8, setShow8] = useState(false);
  const handleClose8 = () => setShow8(false);
  const handleShow8 = () => setShow8(true);
  const childRef = useRef(null);
  const [loginpopshow, setloginpopshowShow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const usrname = useSelector(state => state.user.email);
  const { isFetching, isSuccess, isError, errorMessage } = useSelector(
    userSelector
  );
  useEffect(() => {
    if (isSuccess) {
      setloginpopshowShow(false);
    }
    if (isError) {
      // console.log(errorMessage);
      dispatch(clearState());
    }
  }, [isSuccess, isError]);
  const clickToggleLoginPopup = (showhide) => {
    if (isSuccess) {
      window.location = 'https://ekyc.moneysukh.com:8443/index.aspx';
    }
    else {
      childRef.current.changeTogglePopup(showhide);
    }
  }
  const clickToggleLoginPopupWhy = (showhide, path, blank) => {
    //if (isSuccess) {
    window.open(path, blank);
    //}
    //else {
    // childRef.current.changeTogglePopup(showhide);
    // }
  }
  return (
    <>
      {/* <section className="why-trade">
        <Container className="border-left">
          <Row>
            <Col md={{ span: 12, offset: 0 }} lg={{ span: 10, offset: 1 }}>
              <h2>
                <span>Why trade with us</span>
              </h2>
              <ul>
                {data.map((data, i) => {
                  return (
                    <li key={i}>
                      <img src={data.img} alt="img" />
                      <p>{data.content}</p>
                    </li>
                  );
                })}
              </ul>
            </Col>
          </Row>
        </Container>
      </section> */}
      <section className="why-trade">
        <Container className="border-left">
          <div class="page_heading"><h2><span>Why trade with us</span></h2></div>
          <Row className='justify-content-center d-none'>
            <Col md={{ span: 12 }} lg={{ span: 12 }}>
              <h2>
                <span>Why trade with us fsdf</span>
              </h2>
              <ul>
                <li onClick={handleShow}>
                  <img src={Img1} alt="img" />
                  <p>Trading with AI based trade engine</p>
                </li>
                <li onClick={handleShow1}>
                  <img src={Img2} alt="img" />
                  <p>Earn consistent income</p>
                </li>
                <li onClick={handleShow2}>
                  <img src={Img3} alt="img" />
                  <p>Investment with Zero brokerage</p>
                </li>
                <li onClick={handleShow3}>
                  <img src={Img4} alt="img" />
                  <p>Low risk high return</p>
                </li>
                <li>
                  <a href='https://support.moneysukh.com/' target='_blank'>
                    <img src={Img5} alt="img" />
                    <p>Lightning support</p>
                  </a>
                </li>
                <li onClick={handleShow4}>
                  <img src={Img6} alt="img" />
                  <p>Readymade Screeners</p>
                </li>
                <li>
                  <a onClick={() => clickToggleLoginPopup(true)} target='_blank'>
                    <img src={Img7} alt="img" />
                    <p>Open an account in 5 minutes</p>
                  </a>
                </li>
                <li onClick={handleShow5}>
                  <img src={Img8} alt="img" />
                  <p>Explore IPO / stocks / ETF / commodities</p>
                </li>
                <li onClick={handleShow8}>

                  <img src={Img9} alt="img" />
                  <p>Crack the markets</p>

                </li>
                <li>
                  <a href="/PartnerUs">
                    <img src={Img10} alt="img" />
                    <p>Partner with us</p>
                  </a>
                </li>
                <li onClick={handleShow6}>
                  <img src={Img11} alt="img" />
                  <p>Low cost Algo trading</p>
                </li>
                <li onClick={handleShow7}>
                  <img src={Img12} alt="img" />
                  <p>Live charts</p>
                </li>
              </ul>
              <Modal show={show} onHide={handleClose} className="tool-modal whytradeus_popup">
                <Button variant="secondary" onClick={handleClose} className="btn-close text-right">
                  <MdClose />
                </Button>
                <Modal.Body>
                  <div className='tool-col'>
                    <div className='left-tool'>
                      <img src={Logo} alt="logo" className='img-fluid' />
                      <div className='text-center whytradepopup_imgpanel'>
                        <img src={Popupimg} alt="Popupimg" className='img-fluid' />
                        {/* <h4>A few clicks away <br />from getting in!</h4>
                          <div className='tool-form'>
                            <input type="text" name="name" placeholder="Your Name" />
                            <input type="text" name="name" placeholder="Mobile" />
                            <input type="text" name="name" placeholder="Email" />
                            <a href='#'className='get-start-btn'>GET STARTED</a>
                          </div> */}
                      </div>
                      <div className='viewmorebtn_parent w-100 text-center'>
                        <a href='/TradeRadar' className='get-start-btn'>VIEW MORE</a>
                      </div>
                    </div>
                    <div className='right-tool'>
                      <h3>To trade like a Pro,<br /> First track like a Pro</h3>
                      <p>Technical Signals backed by <br />strong & experience Research</p>
                      <ul>
                        <li>
                          <span><img src={Icon1} alt="Icon" className='img-fluid' /></span>
                          <span>Swing trading / Real time Price breakout</span>
                        </li>
                        <li>
                          <span><img src={Icon2} alt="Icon" className='img-fluid' /></span>
                          <span>Intraday Breakouts / Volume gainers</span>
                        </li>
                        <li>
                          <span><img src={Icon3} alt="Icon" className='img-fluid' /></span>
                          <span>Readymade screeners and scanners</span>
                        </li>
                        <li>
                          <span><img src={Icon4} alt="Icon" className='img-fluid' /></span>
                          <span>Track & Build your own Option Strategies</span>
                        </li>
                        <li>
                          <span><img src={Icon5} alt="Icon" className='img-fluid' /></span>
                          <span>Stock Bottoming / Topping</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
              <Modal show={show1} onHide={handleClose1} className="tool-modal whytradeus_popup">
                <Button variant="secondary" onClick={handleClose1} className="btn-close text-right">
                  <MdClose />
                </Button>
                <Modal.Body>
                  <div className='tool-col'>
                    <div className='left-tool'>
                      <img src={Logo} alt="logo" className='img-fluid' />
                      <div className='text-center whytradepopup_imgpanel'>
                        <img src={Popupimg} alt="Popupimg" className='img-fluid' />
                        {/* <h4>A few clicks away <br />from getting in!</h4>
                          <div className='tool-form'>
                            <input type="text" name="name" placeholder="Your Name" />
                            <input type="text" name="name" placeholder="Mobile" />
                            <input type="text" name="name" placeholder="Email" />
                            <a href='#'className='get-start-btn'>GET STARTED</a>
                          </div>
                           <a href='#'className='get-start-btn'>VIEW MORE</a> */}
                      </div>
                      <div className='viewmorebtn_parent w-100 text-center'>
                        <a href='/Pricing' className='get-start-btn'>VIEW MORE</a>
                      </div>
                    </div>
                    <div className='right-tool'>
                      <h3>To trade like a Pro,<br /> First track like a Pro</h3>
                      <p>Technical Signals backed by <br />strong & experience Research</p>
                      <ul>
                        <li>
                          <span><img src={Icon6} alt="Icon" className='img-fluid' /></span>
                          <span>Get the benefit of Monthly Interest in your account</span>
                        </li>
                        <li>
                          <span><img src={Icon7} alt="Icon" className='img-fluid' /></span>
                          <span>Zero Brokerage delivery.</span>
                        </li>
                        <li>
                          <span><img src={Icon8} alt="Icon" className='img-fluid' /></span>
                          <span>Trade at Rs 20/order</span>
                        </li>
                        <li>
                          <span><img src={Icon9} alt="Icon" className='img-fluid' /></span>
                          <span>0 account opening charges and free subscription to Research Tools</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
              <Modal show={show2} onHide={handleClose2} className="tool-modal whytradeus_popup">
                <Button variant="secondary" onClick={handleClose2} className="btn-close text-right">
                  <MdClose />
                </Button>
                <Modal.Body>
                  <div className='tool-col'>
                    <div className='left-tool'>
                      <img src={Logo} alt="logo" className='img-fluid' />
                      <div className='text-center whytradepopup_imgpanel'>
                        <img src={Popupimg} alt="Popupimg" className='img-fluid' />
                        {/* <h4>A few clicks away <br />from getting in!</h4>
                          <div className='tool-form'>
                            <input type="text" name="name" placeholder="Your Name" />
                            <input type="text" name="name" placeholder="Mobile" />
                            <input type="text" name="name" placeholder="Email" />
                            <a href='#'className='get-start-btn'>GET STARTED</a>
                          </div>
                           <a href='#'className='get-start-btn'>VIEW MORE</a> */}
                      </div>
                      <div className='viewmorebtn_parent w-100 text-center'>
                        <a href='/Pricing' className='get-start-btn'>VIEW MORE</a>
                      </div>
                    </div>
                    <div className='right-tool'>
                      <h3>To trade like a Pro,<br /> First track like a Pro</h3>
                      <p>Technical Signals backed by <br />strong & experience Research</p>
                      <ul>
                        <li>
                          <span><img src={Icon10} alt="Icon" className='img-fluid' /></span>
                          <span>“ZERO” equity delivery charges</span>
                        </li>
                        <li>
                          <span><img src={Icon11} alt="Icon" className='img-fluid' /></span>
                          <span>0 account opening charges and  free subscription to Research Tools</span>
                        </li>
                        <li>
                          <span><img src={Icon12} alt="Icon" className='img-fluid' /></span>
                          <span>get monthly Interest on your ledger balance</span>
                        </li>
                        <li>
                          <span><img src={Icon13} alt="Icon" className='img-fluid' /></span>
                          <span>Trading as low as Rs 10/order </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
              <Modal show={show3} onHide={handleClose3} className="tool-modal whytradeus_popup">
                <Button variant="secondary" onClick={handleClose3} className="btn-close text-right">
                  <MdClose />
                </Button>
                <Modal.Body>
                  <div className='tool-col'>
                    <div className='left-tool'>
                      <img src={Logo} alt="logo" className='img-fluid' />
                      <div className='text-center whytradepopup_imgpanel'>
                        <img src={Popupimg} alt="Popupimg" className='img-fluid' />
                        {/* <h4>A few clicks away <br />from getting in!</h4>
                          <div className='tool-form'>
                            <input type="text" name="name" placeholder="Your Name" />
                            <input type="text" name="name" placeholder="Mobile" />
                            <input type="text" name="name" placeholder="Email" />
                            <a href='#'className='get-start-btn'>GET STARTED</a>
                          </div>
                           <a href='#'className='get-start-btn'>VIEW MORE</a> */}
                      </div>
                      <div className='viewmorebtn_parent w-100 text-center'>
                        <a href='/MFProduct' className='get-start-btn'>VIEW MORE</a>
                      </div>
                    </div>
                    <div className='right-tool'>
                      <h3>To trade like a Pro,<br /> First track like a Pro</h3>
                      <p>Technical Signals backed by <br />strong & experience Research</p>
                      <ul>
                        <li>
                          <span><img src={Icon14} alt="Icon" className='img-fluid' /></span>
                          <span>Simple and easy to select and invest in any mutual fund</span>
                        </li>
                        <li>
                          <span><img src={Icon15} alt="Icon" className='img-fluid' /></span>
                          <span>Invest in Tax saving mutual funds through your mobile</span>
                        </li>
                        <li>
                          <span><img src={Icon16} alt="Icon" className='img-fluid' /></span>
                          <span>Free Sip facility available for every investor</span>
                        </li>
                        <li>
                          <span><img src={Icon17} alt="Icon" className='img-fluid' /></span>
                          <span>Simple and powerful tools to select and invest in any fund</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
              <Modal show={show4} onHide={handleClose4} className="tool-modal whytradeus_popup">
                <Button variant="secondary" onClick={handleClose4} className="btn-close text-right">
                  <MdClose />
                </Button>
                <Modal.Body>
                  <div className='tool-col'>
                    <div className='left-tool'>
                      <img src={Logo} alt="logo" className='img-fluid' />
                      <div className='text-center whytradepopup_imgpanel'>
                        <img src={Popupimg} alt="Popupimg" className='img-fluid' />
                        {/* <h4>A few clicks away <br />from getting in!</h4>
                          <div className='tool-form'>
                            <input type="text" name="name" placeholder="Your Name" />
                            <input type="text" name="name" placeholder="Mobile" />
                            <input type="text" name="name" placeholder="Email" />
                            <a href='#'className='get-start-btn'>GET STARTED</a>
                          </div>
                           <a href='#'className='get-start-btn'>VIEW MORE</a> */}
                      </div>
                      <div className='viewmorebtn_parent w-100 text-center'>
                        <a href='/TradeRadar' className='get-start-btn'>VIEW MORE</a>
                      </div>
                    </div>
                    <div className='right-tool'>
                      <h3>To trade like a Pro,<br /> First track like a Pro</h3>
                      <p>Technical Signals backed by <br />strong & experience Research</p>
                      <ul>
                        <li>
                          <span><img src={Icon18} alt="Icon" className='img-fluid' /></span>
                          <span>Pre-determined strategies for intraday and short term</span>
                        </li>
                        <li>
                          <span><img src={Icon19} alt="Icon" className='img-fluid' /></span>
                          <span>Build your Option strategies</span>
                        </li>
                        <li>
                          <span><img src={Icon20} alt="Icon" className='img-fluid' /></span>
                          <span>Get real-time movements in your alerts section</span>
                        </li>
                        <li>
                          <span><img src={Icon21} alt="Icon" className='img-fluid' /></span>
                          <span>Swing trading at your fingertips is absolutely free.</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
              <Modal show={show5} onHide={handleClose5} className="tool-modal whytradeus_popup">
                <Button variant="secondary" onClick={handleClose5} className="btn-close text-right">
                  <MdClose />
                </Button>
                <Modal.Body>
                  <div className='tool-col'>
                    <div className='left-tool'>
                      <img src={Logo} alt="logo" className='img-fluid' />
                      <div className='text-center whytradepopup_imgpanel'>
                        <img src={Popupimg} alt="Popupimg" className='img-fluid' />
                        {/* <h4>A few clicks away <br />from getting in!</h4>
                          <div className='tool-form'>
                            <input type="text" name="name" placeholder="Your Name" />
                            <input type="text" name="name" placeholder="Mobile" />
                            <input type="text" name="name" placeholder="Email" />
                            <a href='#'className='get-start-btn'>GET STARTED</a>
                          </div>
                           <a href='#'className='get-start-btn'>VIEW MORE</a> */}
                      </div>
                      <div className='viewmorebtn_parent w-100 text-center'>
                        <a href='/Products' className='get-start-btn'>VIEW MORE</a>
                      </div>
                    </div>
                    <div className='right-tool'>
                      <h3>To trade like a Pro,<br /> First track like a Pro</h3>
                      <p>Technical Signals backed by <br />strong & experience Research</p>
                      <ul>
                        <li>
                          <span><img src={Icon22} alt="Icon" className='img-fluid' /></span>
                          <span>Diversify your portfolio via various investment avenues.</span>
                        </li>
                        <li>
                          <span><img src={Icon23} alt="Icon" className='img-fluid' /></span>
                          <span>Scale your return by investing in the latest IPOs/ETF</span>
                        </li>
                        <li>
                          <span><img src={Icon24} alt="Icon" className='img-fluid' /></span>
                          <span>Invest/trade across segments to achieve your goal without delay.</span>
                        </li>
                        <li>
                          <span><img src={Icon25} alt="Icon" className='img-fluid' /></span>
                          <span>Get access to various back-office reports</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
              <Modal show={show6} onHide={handleClose6} className="tool-modal whytradeus_popup">
                <Button variant="secondary" onClick={handleClose6} className="btn-close text-right">
                  <MdClose />
                </Button>
                <Modal.Body>
                  <div className='tool-col'>
                    <div className='left-tool'>
                      <img src={Logo} alt="logo" className='img-fluid' />
                      <div className='text-center whytradepopup_imgpanel'>
                        <img src={Popupimg} alt="Popupimg" className='img-fluid' />
                        {/* <h4>A few clicks away <br />from getting in!</h4>
                          <div className='tool-form'>
                            <input type="text" name="name" placeholder="Your Name" />
                            <input type="text" name="name" placeholder="Mobile" />
                            <input type="text" name="name" placeholder="Email" />
                            <a href='#'className='get-start-btn'>GET STARTED</a>
                          </div>
                           <a href='#'className='get-start-btn'>VIEW MORE</a> */}
                      </div>
                      <div className='viewmorebtn_parent w-100 text-center'>
                        <a href='/TradeTron' className='get-start-btn'>VIEW MORE</a>
                      </div>
                    </div>
                    <div className='right-tool'>
                      <h3>To trade like a Pro,<br /> First track like a Pro</h3>
                      <p>Technical Signals backed by <br />strong & experience Research</p>
                      <ul>
                        <li>
                          <span><img src={Icon26} alt="Icon" className='img-fluid' /></span>
                          <span>Fully Automated at best execution price	</span>
                        </li>
                        <li>
                          <span><img src={Icon2} alt="Icon" className='img-fluid' /></span>
                          <span>Create your own Algo strategy with “0” coding</span>
                        </li>
                        <li>
                          <span><img src={Icon28} alt="Icon" className='img-fluid' /></span>
                          <span>Back test your strategy with Paper trading</span>
                        </li>
                        <li>
                          <span><img src={Icon29} alt="Icon" className='img-fluid' /></span>
                          <span>Earn from sharing as well as investing</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
              <Modal show={show7} onHide={handleClose7} className="tool-modal whytradeus_popup">
                <Button variant="secondary" onClick={handleClose7} className="btn-close text-right">
                  <MdClose />
                </Button>
                <Modal.Body>
                  <div className='tool-col'>
                    <div className='left-tool'>
                      <img src={Logo} alt="logo" className='img-fluid' />
                      <div className='text-center whytradepopup_imgpanel'>
                        <img src={Popupimg} alt="Popupimg" className='img-fluid' />
                        {/* <h4>A few clicks away <br />from getting in!</h4>
                          <div className='tool-form'>
                            <input type="text" name="name" placeholder="Your Name" />
                            <input type="text" name="name" placeholder="Mobile" />
                            <input type="text" name="name" placeholder="Email" />
                            <a href='#'className='get-start-btn'>GET STARTED</a>
                          </div>
                           <a href='#'className='get-start-btn'>VIEW MORE</a> */}
                      </div>
                      <div className='viewmorebtn_parent w-100 text-center'>
                        <a href='/FoxTrader' className='get-start-btn'>VIEW MORE</a>
                      </div>
                    </div>
                    <div className='right-tool'>
                      <h3>To trade like a Pro,<br /> First track like a Pro</h3>
                      <p>Technical Signals backed by <br />strong & experience Research</p>
                      <ul>
                        <li>
                          <span><img src={Icon30} alt="Icon" className='img-fluid' /></span>
                          <span>Get access to multi-asset Live charts at one place</span>
                        </li>
                        <li>
                          <span><img src={Icon31} alt="Icon" className='img-fluid' /></span>
                          <span>Intraday live charts with historical data</span>
                        </li>
                        <li>
                          <span><img src={Icon32} alt="Icon" className='img-fluid' /></span>
                          <span>Backtesting & Scanning through 200+ conditions/signals</span>
                        </li>
                        <li>
                          <span><img src={Icon33} alt="Icon" className='img-fluid' /></span>
                          <span>Visual representations through 3D graphs</span>
                        </li>
                        <li>
                          <span><img src={Icon33} alt="Icon" className='img-fluid' /></span>
                          <span>Readymade conditions to build custom strategies</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
              <Modal show={show8} onHide={handleClose8} className="tool-modal whytradeus_popup">
                <Button variant="secondary" onClick={handleClose8} className="btn-close text-right">
                  <MdClose />
                </Button>
                <Modal.Body>
                  <div className='tool-col'>
                    <div className='left-tool'>
                      <img src={Logo} alt="logo" className='img-fluid' />
                      <div className='text-center whytradepopup_imgpanel'>
                        <img src={Popupimg} alt="Popupimg" className='img-fluid' />
                        {/* <h4>A few clicks away <br />from getting in!</h4>
                          <div className='tool-form'>
                            <input type="text" name="name" placeholder="Your Name" />
                            <input type="text" name="name" placeholder="Mobile" />
                            <input type="text" name="name" placeholder="Email" />
                            <a href='#'className='get-start-btn'>GET STARTED</a>
                          </div>
                           <a href='#'className='get-start-btn'>VIEW MORE</a> */}
                      </div>
                      <div className='viewmorebtn_parent w-100 text-center'>
                        <a href='/research' className='get-start-btn' target='_blank'>VIEW MORE</a>
                      </div>
                    </div>
                    <div className='right-tool'>
                      <h3>To trade like a Pro,<br /> First track like a Pro</h3>
                      <p>Technical Signals backed by <br />strong & experience Research</p>
                      <ul>
                        <li>
                          <span><img src={Icon30} alt="Icon" className='img-fluid' /></span>
                          <span>IPO Coverage</span>
                        </li>
                        <li>
                          <span><img src={Icon31} alt="Icon" className='img-fluid' /></span>
                          <span>Daily Derivative Updates</span>
                        </li>
                        <li>
                          <span><img src={Icon32} alt="Icon" className='img-fluid' /></span>
                          <span>Latest Economic Reports</span>
                        </li>
                        <li>
                          <span><img src={Icon33} alt="Icon" className='img-fluid' /></span>
                          <span>Daily Morning Updates</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
            </Col>
          </Row>
          <div className='whytradeusnew_area'>
            <div className='row'>
              <div className='col-md-6'>
                <div className='whytradeusnew_grid'>
                  <div className='whytradeusnew_group d-flex'>
                    <div className='whytradeusnew_text'>
                      <h3>Intraday Live Charts <small>(Fox Trader)</small></h3>
                      <p>Analyse charts with 200+ signals across time frames</p>
                      <a onClick={() => clickToggleLoginPopupWhy(true, '/FoxTrader', "_self")} class="readMore" style={{ cursor: "pointer" }}>Read More</a>
                    </div>
                    <div className='whytradeusnew_imgpanel'>
                      <img src={whytradefoxtrader} className='img-fluid'></img>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='whytradeusnew_grid'>
                  <div className='whytradeusnew_group d-flex'>
                    <div className='whytradeusnew_text'>
                      <h3>Algo World</h3>
                      <p>Automate your trading strategies with target and stoploss</p>
                      <a onClick={() => clickToggleLoginPopupWhy(true, '/AlgoTrading', "_self")} class="readMore" style={{ cursor: "pointer" }}>Read More</a>
                    </div>
                    <div className='whytradeusnew_imgpanel'>
                      <img src={whytradealgo} alt='whytradealgo' className='img-fluid'></img>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='whytradeusnew_grid'>
                  <div className='whytradeusnew_group d-flex align-items-end'>
                    <div className='whytradeusnew_text'>
                      <h3>Option Strategies</h3>
                      <p>Track & Build Option Strategies with real time market screeners</p>
                      <a onClick={() => clickToggleLoginPopupWhy(true, '/TradeRadar', "_self")} class="readMore" style={{ cursor: "pointer" }}>Read More</a>
                    </div>
                    <div className='whytradeusnew_imgpanel'>
                      <img src={whytradeoption} alt='whytradeoption' className='img-fluid'></img>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='whytradeusnew_grid'>
                  <div className='whytradeusnew_group d-flex'>
                    <div className='whytradeusnew_text'>
                      <h3>Crack the Markets</h3>
                      <p>Get daily market updates and research reports</p>
                      <a onClick={() => clickToggleLoginPopupWhy(true, '/research', "_blank")} class="readMore" style={{ cursor: "pointer" }}>Read More</a>
                    </div>
                    <div className='whytradeusnew_imgpanel'>
                      <img src={whytradecrackmarkets} alt='whytradecrackmarkets' className='img-fluid'></img>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='whytradeusnew_grid'>
                  <div className='whytradeusnew_group d-flex'>
                    <div className='whytradeusnew_text'>
                      <h3>Pricing</h3>
                      <p>Get interest on ledger balance on monthly basis</p>
                      <a onClick={() => clickToggleLoginPopupWhy(true, '/Pricing', '_self')} class="readMore" style={{ cursor: "pointer" }}>Read More</a>
                    </div>
                    <div className='whytradeusnew_imgpanel'>
                      <img src={whytradecrapprice} alt='whytradefoxtrader' className='img-fluid' ></img>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='whytradeusnew_grid'>
                  <div className='whytradeusnew_group d-flex align-items-end'>
                    <div className='whytradeusnew_text'>
                      <h3>Lightning Support</h3>
                      <p>We’re here for you whenever you need our support.</p>
                      <a onClick={() => clickToggleLoginPopupWhy(true, 'https://support.moneysukh.com/', '_self')} class="readMore" style={{ cursor: "pointer" }}>Read More</a>
                    </div>
                    <div className='whytradeusnew_imgpanel'>
                      <img src={whytradesupport} className='img-fluid'></img>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div class="col-md-12">
                <div class="whytradeusnew_grid">
                  <div class="whytradeusnew_group p-0">
                    <div class="whytradeusnew_imgpanel w-100">
                      <a href="/Quantman">
                        <img src={quantmanhome} class="img-fluid" />
                      </a>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </Container>
      </section>
      <LoginPopup show={loginpopshow} ref={childRef} />
    </>
  );
}
export default WhyUs;
